import React, { useEffect } from "react";
import { Redirect, navigate, useLocation } from "@reach/router";
import useUser from "../hooks/useUser";
import _ from "lodash";
import { checkKeys } from "../helpers/functions";

export default function ProtectedRoute({ ...props }) {
  const { userObject } = useUser();
  const location = useLocation();

  function getCaseId(url) {
    const match = url.match(/\/cases\/(\d+)/);
    return match ? match[1] : null;
  }

  const queryParams = new URLSearchParams(location.search);
  const authToken = queryParams.get("authToken");
  const caseType = queryParams.get("caseType");
  const caseId = getCaseId(location.href);

  useEffect(() => {
    if (authToken && caseId) {
      localStorage.setItem("auth_token", authToken);

      navigate(`/dashboard/cases/${caseId}?caseType=${caseType}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken, caseId]);

  useEffect(() => {
    if (!_.isEmpty(userObject)) {
      if (!userObject.emailVerified) {
        navigate("/not-verifed");
      }
      if (checkKeys(userObject)) {
        navigate("/create-profile");
      }
    }
  }, [userObject]);
  return localStorage.getItem("auth_token") ? (
    props.children
  ) : (
    <Redirect to="/" noThrow />
  );
}
